import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';

import { Formik } from 'formik';

import {
    KeyboardTimePicker,
    KeyboardDatePicker
} from '@material-ui/pickers';


import {
    Switch,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid
} from '@material-ui/core';


const Schedule = ({ item, closeSchedule, updateSchedule, open }) => {

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Programa
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({
                                    name: Yup.string().max(70).required('Nome é obrigatório'),
                                    description: Yup.string().max(100).required('Descrição é o obrigatória'),
                                    defaultInactivityOverflow: Yup.number().required('Tempo para reinício é obrigatório')
                                })
                            }
                            onSubmit={(values, formik) => {
                                updateSchedule(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                setFieldValue,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid
                                        container
                                        spacing={2}
                                    >
                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.name && errors.name)}
                                                fullWidth
                                                helperText={touched.name && errors.name}
                                                label="Nome"
                                                margin="normal"
                                                name="name"
                                                rows={2}
                                                multiline
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.name}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.description && errors.description)}
                                                fullWidth
                                                helperText={touched.description && errors.description}
                                                label="Descrição"
                                                margin="normal"
                                                name="description"
                                                rows={2}
                                                multiline
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.description}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>


                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                cancelLabel="Cancelar"
                                                disabled={true}
                                                inputVariant="outlined"
                                                margin="normal"
                                                id="date-picker-dialog1"
                                                label="Data da Última Execução"
                                                format="DD/MM/YYYY"
                                                name="lastInactivityCheck"
                                                onChange={value => setFieldValue("lastInactivityCheck", value)}
                                                value={values.lastInactivityCheck}
                                                onBlur={handleBlur}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <KeyboardTimePicker
                                                disabled={true}
                                                cancelLabel="Cancelar"
                                                inputVariant="outlined"
                                                margin="normal"
                                                id="time-picker1"
                                                format="HH:mm:ss"
                                                label="Hora da Última Execução"
                                                name="lastInactivityCheck"
                                                value={values.lastInactivityCheck}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("lastInactivityCheck", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                cancelLabel="Cancelar"
                                                margin="normal"
                                                inputVariant="outlined"
                                                id="date-picker-dialog2"
                                                label="Data da Próxima Execução"
                                                format="DD/MM/YYYY"
                                                name="nextInactivityCheck"
                                                value={values.nextInactivityCheck}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("nextInactivityCheck", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <KeyboardTimePicker
                                                margin="normal"
                                                inputVariant="outlined"
                                                cancelLabel="Cancelar"
                                                id="time-picker2"
                                                format="HH:mm:ss"
                                                label="Hora da Próxima Execução"
                                                name="nextInactivityCheck"
                                                value={values.nextInactivityCheck}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("nextInactivityCheck", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>
                                            <label>
                                                <Typography>Habilitar reinício Automático</Typography>
                                                <Switch
                                                    id={values._id}
                                                    checked={values.automaticRestart}
                                                    name="automaticRestart"
                                                    onChange={handleChange} />

                                            </label>
                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.defaultInactivityOverflow && errors.defaultInactivityOverflow)}
                                                fullWidth
                                                helperText={touched.defaultInactivityOverflow && errors.defaultInactivityOverflow}
                                                label="Reinicio Automático em Minutos"
                                                margin="normal"
                                                name="defaultInactivityOverflow"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.defaultInactivityOverflow}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.data && errors.data)}
                                                fullWidth
                                                helperText={touched.data && errors.data}
                                                label="Código do Alarme de Erro"
                                                margin="normal"
                                                name="defaultInactivityOverflow"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.data}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>
                                            <label>
                                                <Typography>Habilitar / Desebilitar Alarme</Typography>
                                                <Switch
                                                    id={values._id}
                                                    checked={values.enabled}
                                                    name="enabled"
                                                    onChange={handleChange} />

                                            </label>
                                        </Grid>
                                    </Grid>
                                    <Box my={1}></Box>
                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained">
                                                    Salvar
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeSchedule() }}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Schedule;
